import { endpoint } from "../../common/constant";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

export const NEW_EMPTY_ROW = {
  isNew: true,

  status: "ACTIVE",
  description: null,
  displayValue: null,
};

export const getStudentCategories = async (page = 0, pageSize = 50) => {
  const res = await fetchAllPromisedData(
    `${endpoint?.studentCategories}?page=${page}&size=${pageSize}`
  );

  if (res?.content?.length) {
    return res;
  }

  return {};
};
